import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



function RenewableEnergyListing() {
  // 🔹 States
  const [plants, setPlants] = useState([]);
  //const [banners, setBanners] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true); // ✅ IMPORTANT
  const plantsPerPage = 6;

  const slugify = (text = "") =>
    text
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");

  // 🔹 Default local banners
  // const localBanners = [img1, img2, img3];

  // 🔹 Fetch renewable energy plants
  const fetchPlants = async (page = 1) => {
    try {
      setLoading(true);

      const res = await fetch(
        `https://backend-zkgn.onrender.com/api/renewableplants?page=${page}&limit=${plantsPerPage}`,
      );
      const data = await res.json();

      setPlants(data.plants || []);
      setTotalPages(data.totalPages || 1);
      setCurrentPage(data.page || 1);
    } catch (error) {
      console.error("Error fetching renewable plants:", error);
      setPlants([]);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Fetch banners
  // const fetchBanners = async () => {
  //   try {
  //     const res = await fetch(
  //       "https://backend-zkgn.onrender.com/api/banners/insidebanner",
  //     );
  //     const data = await res.json();

  //     if (Array.isArray(data) && data.length > 0) {
  //       setBanners(data);
  //     } else {
  //       setBanners(
  //         localBanners.map((src, i) => ({
  //           banner_image_link: src,
  //           banner_id: i + 1,
  //           website: "",
  //         })),
  //       );
  //     }
  //   } catch {
  //     setBanners(
  //       localBanners.map((src, i) => ({
  //         banner_image_link: src,
  //         banner_id: i + 1,
  //         website: "",
  //       })),
  //     );
  //   }
  // };

  // 🔹 Initial load
  useEffect(() => {
    fetchPlants();
    // fetchBanners();
  }, []);

  // 🔹 Search filter
  const filteredPlants = plants.filter((plant) => {
    const keyword = search.toLowerCase();
    return (
      plant.renergy_name?.toLowerCase().includes(keyword) ||
      plant.renergy_city?.toLowerCase().includes(keyword) ||
      plant.renergy_state?.toLowerCase().includes(keyword)
    );
  });

  // 🔹 Pagination
  const totalFilteredPages = Math.ceil(filteredPlants.length / plantsPerPage);
  const total = Math.max(totalFilteredPages, totalPages);

  const indexOfLast = currentPage * plantsPerPage;
  const indexOfFirst = indexOfLast - plantsPerPage;
  const currentPlants = filteredPlants.slice(indexOfFirst, indexOfLast);

  const paginate = (page) => setCurrentPage(page);
  const goToPreviousPage = () =>
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, total));

  // 🔹 Compact pagination numbers
  const getPageNumbers = () => {
    const pages = [];
    if (total <= 5) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", total);
      } else if (currentPage >= total - 2) {
        pages.push(1, "...", total - 3, total - 2, total - 1, total);
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          total,
        );
      }
    }
    return pages;
  };

  return (
    <div className="container-fluid my-5">
      <div className="row">
        <div className="col-lg-12">
          {/* 🔹 Header */}
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <h5 className="fw-bold text-tertiry">
                {loading ? (
                  "Loading renewable energy plants..."
                ) : (
                  <>
                    <strong>{filteredPlants.length}</strong> Renewable energy
                    plants found
                  </>
                )}
              </h5>
            </div>

            <div className="col-md-6">
              <input
                type="text"
                className="form-control search-box"
                placeholder="Search by name, city, or state..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                disabled={loading}
              />
            </div>
          </div>

          {/* 🔹 Listing */}
          <div className="row g-4">
            {loading ? (
              <div className="col-12 text-center py-5">
                <div
                  className="spinner-border text-primary"
                  role="status"
                ></div>
                <p className="mt-2 text-muted">
                  Fetching renewable energy plants…
                </p>
              </div>
            ) : currentPlants.length > 0 ? (
              currentPlants.map((plant) => (
                <div className="col-md-6" key={plant.renergy_id}>
                  <div className="card shadow-sm plant-card h-100">
                    <div className="card-body">
                      <h5 className="card-title fw-bold">
                        <Link
                          to={`/renewableenergy/${slugify(
                            plant.renergy_name,
                          )}/${plant.renergy_id}`}
                          className="text-decoration-none"
                        >
                          {plant.renergy_name}
                        </Link>
                      </h5>

                      <p className="mb-1">
                        <strong className="text-orange">Address:</strong>{" "}
                        {plant.renergy_address || "N/A"}
                      </p>

                      <p className="mb-0">
                        <strong className="text-orange">Phone:</strong>{" "}
                        {plant.renergy_phone || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="alert alert-warning text-center w-100">
                No renewable energy plants found.
              </div>
            )}
          </div>

          {/* 🔹 Pagination */}
          {!loading && total > 1 && (
            <nav className="d-flex justify-content-center mt-4">
              <ul className="pagination pagination-sm shadow-sm">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button className="page-link" onClick={goToPreviousPage}>
                    ← Previous
                  </button>
                </li>

                {getPageNumbers().map((page, i) =>
                  page === "..." ? (
                    <li key={i} className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  ) : (
                    <li
                      key={i}
                      className={`page-item ${
                        currentPage === page ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(page)}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}

                <li
                  className={`page-item ${
                    currentPage === total ? "disabled" : ""
                  }`}
                >
                  <button className="page-link" onClick={goToNextPage}>
                    Next →
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>
    </div>
  );
}

export default RenewableEnergyListing;
